import { meteorEndpoint } from "../data/meteor-server";

const LOGIN_TOKEN_KEY = `${meteorEndpoint}__login_token__`;
const HAVEN_LOGIN_TOKEN_KEY = "haven__login_token__";

export const userLoginToken = (): string | null =>
  localStorage.getItem(LOGIN_TOKEN_KEY) ?? localStorage.getItem(HAVEN_LOGIN_TOKEN_KEY);

export const loginWithToken = (token: string): void => localStorage.setItem(LOGIN_TOKEN_KEY, token);
export const loginWithHavenToken = (token: string): void =>
  localStorage.setItem(HAVEN_LOGIN_TOKEN_KEY, token);
export const wipeToken = (): void => {
  localStorage.removeItem(LOGIN_TOKEN_KEY);
  localStorage.removeItem(HAVEN_LOGIN_TOKEN_KEY);
  localStorage.removeItem("Meteor.loginToken");
  localStorage.removeItem("meteorUserId");
  localStorage.removeItem("Meteor.loginTokenExpires");
  localStorage.removeItem("Meteor.userId");
};

// export const userIsAuthenticated = (): boolean => userLoginToken() !== null;
